import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import _ from 'lodash';
import { sendDeleteRequest, sendPostRequest } from '../services/PDService';

export const getApiKey = createAsyncThunk(
  'speechToText/getApiKey',
  async (payload, { getState, dispatch, rejectWithValue }) => {
    const response = await sendPostRequest('deepgram-token');
    if (response.data?.data) {
      return response.data.data;
    } else if (response.error) {
      rejectWithValue(response.error);
    }
    rejectWithValue(null);
  }
);

export const deleteApiKey = createAsyncThunk(
  'speechToText/deleteApiKey',
  async (payload, { getState, dispatch, rejectWithValue }) => {
    console.log(getState());
    if (!getState().speechToText?.apiKeyData?.api_key_id) {
      rejectWithValue(null);
    }
    const response = await sendDeleteRequest(
      `deepgram-token/${getState().speechToText.apiKeyData.api_key_id}`
    );
    if (response.data?.data) {
      return response.data.data;
    } else if (response.error) {
      rejectWithValue(response.error);
    }
    rejectWithValue(null);
  }
);

const SpeechToTextSlice = createSlice({
  name: 'speechToText',
  initialState: {
    status: 'idle',
    error: null,
    apiKeyData: null,
  },
  reducers: {
    resetSpeechToText: (state, action) => {
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: {
    [getApiKey.pending]: (state, action) => {
      state.status = 'pending';
    },
    [getApiKey.rejected]: (state, action) => {
      state.status = 'rejected';
      state.error = action.payload ?? 'Failed to connect';
    },
    [getApiKey.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.apiKeyData = action.payload;
    },
  },
});

export const apiKeySelector = (state) => {
  return state?.speechToText?.apiKeyData?.key ?? '';
};

export const { resetSpeechToText } = SpeechToTextSlice.actions;
export default SpeechToTextSlice;
